import useStore from '@/store/main'
import { Directive, DirectiveBinding } from 'vue'

/**
 * 按钮权限校验
 */
// export const hasPerm: Directive = {
//   mounted(el: HTMLElement, binding: DirectiveBinding) {
//     // 「超级管理员」拥有所有的按钮权限
//     const { user } = useStore()
//     const roles = user.roles;
//     if (roles.includes('ROOT')) {
//       return true
//     }
//     // 「其他角色」按钮权限校验
//     const { value } = binding;
//     if (value) {
//       const requiredPerms = value; // DOM绑定需要的按钮权限标识
//       console.log(requiredPerms, '////////////////');
//       const hasPerm = user.perms.some(perm => {
//         return requiredPerms.includes(perm)
//       })

//       if (!hasPerm) {
//         el.parentNode && el.parentNode.removeChild(el);
//       }
//     } else {
//       throw new Error("need perms! Like v-has-perm=\"['sys:user:add','sys:user:edit']\"");
//     }
//   }
// };

/**
 * 角色权限校验
 */
export const hasRole: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // 「超级管理员」拥有所有的权限
    const { user } = useStore()
    const roles = user.roles
    if (roles.includes('ROOT')) {
      return true
    }
    // 「其他角色」权限校验
    const { value } = binding
    if (value) {
      const requiredPerms = value // DOM绑定需要的权限标识
      const hasPerm = requiredPerms.filter((item: string) => {
        return roles.indexOf(item) !== -1
      })
      if (!hasPerm || !hasPerm.length) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error('need roles! Like v-has-role="[\'ROOT\']"')
    }
  },
}
